<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import Grid from '../Shared/Grid'
export default {
  name: 'CourseAffiliates',
  props: ['courseId'],
  components: {
    Grid
  },
  data () {
    return {
      filterable: true,
      module: this.$route.meta.module,
      columnOptions: [
        { field: (col) => col.AFFILIATE_NAME, name: 'AFFILIATE_NAME', label: 'Affiliate Name', sortable: true, filter: null, type: 'string' },
        { field: (col) => col.AFFILIATE_CODE, name: 'AFFILIATE_CODE', label: 'Affiliate Code', sortable: true, filter: null, type: 'string' },
        { field: (col) => col.STUDENT_PROCESSING_FEE, name: 'STUDENT_PROCESSING_FEE', label: 'Student Processing Fee', sortable: true, filter: null, type: 'number' },
        { field: (col) => col.ACTIVE_IND, name: 'ACTIVE_IND', label: 'Affiliate Status', sortable: true, filter: '', type: 'string' }
      ]
    }
  },
  computed: {
    ...mapState('courses', {
      selectedAffiliates: state => state.selectedAffiliates,
      courseAffiliatePagination: state => state.courseAffiliatePagination
    }),
    ...mapGetters('courses', [
      'affiliateList'
    ])
  },
  methods: {
    ...mapMutations('courses', [
      'updateSelectedAffiliates', 
      'clearSelectedAffiliates'
    ]),
    ...mapActions('courses', [
      'fetchAffiliates'
    ])
  }
}
</script>

<template>
  <div class="">
    <Grid 
      selectable="multiple"
      id="courseAffiliate"
      :data="affiliateList"
      :pagination="courseAffiliatePagination"
      :columns="columnOptions"
      :onRequest="fetchAffiliates"
      :onSelect="updateSelectedAffiliates"
      :selected="selectedAffiliates"
    >
      <template slot="col-item-active_ind" slot-scope="props">
        <div style="display:inline-block;margin-left: 10px;border-radius:30px" 
          class="label"
          :class="{
              'green' : props.value === 1,
              'red' : props.value === 0
          }">
          {{props.value ? 'Active' : 'Inactive'}}
        </div>
      </template>
    </Grid>
  </div>
</template>

<style>
</style>